import React from "react";
import {account$, backToAdminView} from "../../../../../emitters/account";
import Ripple from "../../../../dumb/Ripple";

export default (account) => {

  if (!account) {
    account = account$.getValue() || {};
  }

  const adminIsLogged = account.login_site !== 'default' && !!(account.login_site || {}).console;

  const signOutText = adminIsLogged
    ? 'To Admin View'
    : 'Log Out';
  const signOutFN = adminIsLogged
    ? backToAdminView
    : account$.signOut;

  return (
    <Ripple onClick={signOutFN} data-testid="logout">
      {signOutText}
    </Ripple>
  )
}
